import { Routes, Route } from "react-router-dom";
import PrivateRoutes from './utils/PrivateRoutes';
import ProtectedRoutes from './utils/ProtectedRoutes';
import { priveRoutes, publicRoutes } from './routers'
import { DefaultLayout } from "./layouts/defaultLayout";
import { NotFoundPage } from "./pages/notFound";
import './App.css';
import { ToastContextProvider } from "./components/ToastContextProvider";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./app/store";
import jwtDecode from "jwt-decode";
import { signOut } from "./reducers/authSlice";

function App() {
  const Layout = DefaultLayout;
  const { token } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    getData();
  }, [])

  const getData = async () => {
    // const data = { q: "hospital" };
    // let response = await fetch(`https://google.serper.dev/search`, {
    //   method: 'POST',
    //   headers: {
    //     'X-API-KEY': 'bc83eca1578ef0976e79bb792f8e91111bb41111',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify(data)
    // });
    // let responseJson = await response.json();
    // console.log(responseJson);
  }

  useEffect(() => {
    let timer = setInterval(() => {
      try {
        if (token) {
          const data: any = jwtDecode(token);
          const exp = data.exp;
          const timeNow = Math.ceil(new Date().getTime() / 1000);
          if (exp - timeNow <= 0) {
            dispatch(signOut());
          }
        }
      } catch (error) {
        console.log(error);
      }
    }, 1000)
    return () => {
      clearInterval(timer);
    }
  }, [dispatch, token])

  return (
    <div className="App">
      <Routes>
        <Route path='*' element={<NotFoundPage />} />
        <Route element={<PrivateRoutes />}>
          {priveRoutes.map((route, index) => {
            const Page = route.element;
            return (
              <Route key={index} path={route.path} element={
                <ToastContextProvider>
                  <Layout>
                    <Page />
                  </Layout>
                </ToastContextProvider>
              } />
            );
          })}
        </Route>
        <Route element={<ProtectedRoutes />}>
          {publicRoutes.map((route, index) => {
            const Page = route.element;
            return (
              <Route key={index} path={route.path} element={
                <ToastContextProvider>
                  <Page />
                </ToastContextProvider>
              }
              />
            );
          })}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
